import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { StudentAthleteService } from '@app/modules/compliance/services/student-athlete.service';
import { ApiResult } from '@app/shared/model/apiresult';


@Component({
    selector: 'add-student-dialog',
    templateUrl: './add-student-dialog.component.html'
})
// Not using this Dialog but kept it for reference.
export class AddStudentDialog implements OnInit {
    hasInstitutionId: boolean;
    validInstitutionId: boolean = true;
    institutionId: string;
    hasWorkdayId: boolean;
    validWorkdayId: boolean = true;
    workdayId: string
    errorMessage:string;
    constructor(
        public dialogRef: MatDialogRef<AddStudentDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router,
        private _studentathleteservice: StudentAthleteService
    ) { }
    ngOnInit() {

    }
    public navigateCompliance(e: any) {
        this.hasInstitutionId = e.checked;
    }
    public navigateWorkdayCompliance(e: any) {
        this.hasWorkdayId = e.checked;
    }
    public proceed() {
        if (this.hasInstitutionId) {
            if (this.institutionId.length != 9) {
                this.validInstitutionId = false;
                this.errorMessage='Invalid Institution ID';
            }
            else {
                this.validInstitutionId = true;
                this._studentathleteservice.checkStudentLsuId(this.institutionId).subscribe((result: ApiResult<any>) => {
                    if (result.validationErrors == null && result.value != null) {
                        this.dialogRef.close();
                        this.router.navigate(['/compliance', ''], { queryParams: {institutionId: this.institutionId}});
                    }
                    else {
                        this.errorMessage = result.validationErrors[0];
                        //this.errorMessage='Institution ID already exists.';
                        this.validInstitutionId = false;
                    }
                }, error => console.error(error));
            }
        }
        else {
            this.dialogRef.close();
            this.router.navigate(['/compliance']);
        }
    }
}